export function formatOrderby(sortby?: string, asc?: boolean): string | null {
  if (sortby) {
    return `${sortby} ${asc ? "asc" : "desc"}`;
  }

  return null;
}

export function formatOrderbyArray(sortby: string[], asc: boolean[]): string | null {
  return !sortby || sortby.length == 0
    ? null
    : sortby.map((x, idx) => formatOrderby(sortby[idx], asc[idx])).join(",");
}